var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveService({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 9.16634C2.69873 9.16634 0.833313 7.30092 0.833313 4.99967C0.833313 2.69842 2.69873 0.833008 4.99998 0.833008C7.30123 0.833008 9.16665 2.69842 9.16665 4.99967C9.16665 7.30092 7.30123 9.16634 4.99998 9.16634ZM4.99998 4.41051L3.82165 3.23176L3.23206 3.82134L4.41081 4.99967L3.23206 6.17801L3.82165 6.76759L4.99998 5.58884L6.17831 6.76759L6.7679 6.17801L5.58915 4.99967L6.7679 3.82134L6.17831 3.23176L4.99998 4.41051Z",
    fill: "#D9E5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveService);
export default __webpack_public_path__ + "static/media/remove-service.6b92090e28c8277b6224371e5c98135a.svg";
export { ForwardRef as ReactComponent };